import { render, staticRenderFns } from "./c_textarea.vue?vue&type=template&id=67cf1fde&scoped=true"
import script from "./c_textarea.vue?vue&type=script&lang=js"
export * from "./c_textarea.vue?vue&type=script&lang=js"
import style0 from "./c_textarea.vue?vue&type=style&index=0&id=67cf1fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf1fde",
  null
  
)

export default component.exports